module.exports = __webpack_public_path__ + "assets/img/menlist.ea047605.png";